import { createContext } from 'react';
const AnimationsContext = createContext();
export default AnimationsContext;
